var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f1410098-b6ef-424e-beee-8c1519bc1d1f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 915.68773,
    height: 679.27607,
    viewBox: "0 0 915.68773 679.27607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5076013-d6c0-4649-8f63-d536232108ef",
    x1: 549.23403,
    y1: 734.77229,
    x2: 549.23403,
    y2: 126.56914,
    gradientTransform: "matrix(0.97485, 0.30762, -0.30291, 0.99, 144.20301, -171.28919)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be72c466-93ff-4e9c-a64c-30b94918ee69",
    x1: 549.32281,
    y1: 679.27607,
    x2: 549.32281,
    y2: 233.83602,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b5076013-d6c0-4649-8f63-d536232108ef"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Credit card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.85689,
    y: 201.52958,
    width: 728.622,
    height: 445.00176,
    rx: 27.5,
    transform: "translate(-243.24579 71.69262) rotate(-17.2615)",
    fill: "url(#b5076013-d6c0-4649-8f63-d536232108ef)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.71997,
    y: 205.56022,
    width: 713.75592,
    height: 429.25181,
    rx: 27.5,
    transform: "translate(-242.04064 71.94381) rotate(-17.2615)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9523,
    y: 267.86085,
    width: 713.75592,
    height: 61.55937,
    transform: "translate(-207.67506 55.26252) rotate(-17.2615)",
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 303.66876,
    y: 610.48755,
    width: 181.35057,
    height: 26.62027,
    transform: "translate(-309.4966 34.74867) rotate(-17.2615)",
    fill: "#bdbdbd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 287.34157,
    y: 547.84131,
    width: 314.45191,
    height: 26.62027,
    transform: "translate(-288.64532 46.83008) rotate(-17.2615)",
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 182.9579,
    y: 233.83602,
    width: 732.72983,
    height: 445.44005,
    rx: 27.5,
    fill: "url(#be72c466-93ff-4e9c-a64c-30b94918ee69)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 191.27673,
    y: 238.37789,
    width: 713.75592,
    height: 429.25181,
    rx: 27.5,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 361.01292,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 387.63319,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 414.25346,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 460.83892,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 487.45919,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 514.07946,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 560.66493,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 587.28519,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 613.90546,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 660.49093,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 687.1112,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 713.73147,
    y: 446.76044,
    width: 20.79708,
    height: 59.06372,
    fill: "#e0e0e0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 236.68773,
    y: 350.83602,
    width: 124,
    height: 68,
    fill: "#6c63ff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 718.68773,
    y: 573.83602,
    width: 76,
    height: 76,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 756.68773,
    y: 573.83602,
    width: 76,
    height: 76,
    fill: "#6c63ff",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCreditcard);
export default __webpack_public_path__ + "static/media/empty_creditcard.9336d456a5d175f4c0dac7144cdf6589.svg";
export { ForwardRef as ReactComponent };